import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConsultaService } from 'src/app/services/http/consulta.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { UtilMasks } from 'src/app/utils/util-masks';
import { UtilValidators } from 'src/app/utils/util-validators';
import { RealizarConsultaService } from 'src/app/services/http/realizar-consulta.service';
import { ModalMsgService } from 'src/app/services/modal-msg.service';

@Component({
  selector: 'app-modal-editar-consulta',
  templateUrl: './modal-editar-consulta.component.html',
  styleUrls: ['./modal-editar-consulta.component.scss']
})
export class ModalEditarConsultaComponent implements OnInit {
  @ViewChild('modalRealizarConsulta', { static: false }) contentModal;
  @Input() tokenConsulta = '';
  @Input() consultasExecutadas = [];
  @Input() placaEntrada = '';
  @Input() chassiEntrada = '';
  @Input() motorEntrada = '';
  @Input() documentoEntrada = '';
  @Input() cnhEntrada = '';
  @Input() crlvEntrada = '';
  tipoPesquisaVeiculo = 'placa';
  listaConsultas: any[] = [];
  form = new FormGroup({});
  totalConsultas = 0;
  masks = {
    documento: { mask: UtilMasks.documento, guide: false },
    placa: { mask: UtilMasks.placa, guide: false },
  }

  controlVeiculoPlaca = new FormControl('', [Validators.required, Validators.minLength(7)]);
  controlVeiculoChassi = new FormControl('', [Validators.required, Validators.maxLength(17)]);
  controlVeiculoMotor = new FormControl('', [Validators.required, Validators.maxLength(99)]);
  controlDocumento = new FormControl('', [Validators.required, UtilValidators.documento]);
  controlCNH = new FormControl('', [Validators.required, Validators.minLength(11), Validators.maxLength(14)]);
  controlCRLV = new FormControl('', [Validators.required, Validators.minLength(9)]);
  modalconfirmar = false;
  constructor(private modalMsgService: ModalMsgService, private realizarConsultaService: RealizarConsultaService, private consultaService: ConsultaService, private modalService: NgbModal) { }

  ngOnInit() {
  }

  checkedChange() {
    this.displayForm();
    this.totalConsultas = this.listaConsultas.filter( c => !c.disabled && c.checked).length;
  }

  displayForm() {

    let habilitaCRLV = !!this.listaConsultas.find(c => c.checked && c.tipoConsulta == 'CRLV');
    let habilitaCNH = !!this.listaConsultas.find(c => c.checked && c.tipoConsulta == 'CNH');
    let habilitaDocumento = !!this.listaConsultas.find(c => c.checked && c.tipoConsulta == 'LOCALIZA_VEICULO');

    let totalConsultas = this.listaConsultas.filter(c => c.checked).length;
    if (habilitaCNH) totalConsultas--;
    if (habilitaCRLV) totalConsultas--;
    if (habilitaDocumento) totalConsultas--;

    let habilitaVeiculo = totalConsultas > 0;

    if (habilitaCNH && !this.cnhEntrada) {
      this.form.addControl('cnh', this.controlCNH);
    } else {
      this.form.removeControl('cnh');
    }

    if (habilitaCRLV && !this.crlvEntrada) {
      this.form.addControl('crlv', this.controlCRLV);
    } else {
      this.form.removeControl('crlv');
    }

    if (habilitaDocumento && !this.documentoEntrada) {
      this.form.addControl('documento', this.controlDocumento);
    } else {
      this.form.removeControl('documento');
    }

    if (habilitaVeiculo && !this.placaEntrada && !this.chassiEntrada && !this.motorEntrada) {
      this.setControlVeiculo();
    } else {
      this.form.removeControl('veiculo');
    }

  }

  setControlVeiculo() {
    if (this.tipoPesquisaVeiculo == 'placa') {
      this.form.setControl('veiculo', this.controlVeiculoPlaca);
    }
    if (this.tipoPesquisaVeiculo == 'chassi') {
      this.form.setControl('veiculo', this.controlVeiculoChassi);
    }
    if (this.tipoPesquisaVeiculo == 'motor') {
      this.form.setControl('veiculo', this.controlVeiculoMotor);
    }
  }


  confirmar(modal) {
    if(this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.modalMsgService.open('Deseja finalizar a consulta: '+ this.tokenConsulta +'?', '', 'warning').then(r => {
      if(r=='ok') {
        modal.close(r);
      }
    })
  }

  async showModal() {
    try {
      this.totalConsultas = 0;
      let r = await this.consultaService.listaConsulta();
      this.listaConsultas = r;
      this.listaConsultas.forEach(c => {
        let consultaExecutada = (this.consultasExecutadas.find(cx => cx.tipoConsulta == c.tipoConsulta));
        if (consultaExecutada) {
          c.disabled = true;
          c.checked = true;
        }
      });
      this.displayForm();
    } catch (error) {
      console.error('erro ao buscar lista de consultas');
    }
    try {
      let modalResult = await this.modalService.open(this.contentModal, { backdrop: "static", windowClass: 'modal-fullscreen', ariaLabelledBy: 'Modal editar consulta' }).result;
      if(modalResult=='ok') {
        return this.salvarEdicao();
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  }

  async salvarEdicao() {
    let json = {
      idConsultaVeiculo: this.tokenConsulta,
      listaConsultasSelecionado: this.listaConsultas.filter( c => c.checked ),
    }

    let values = this.form.value;

    if(values.crlv) {
      json['crlv'] = values.crlv;
    }

    if(values.documento) {
      json['documento'] = values.docmento;
    }

    if(values.cnh) {
      json['cnh'] = values.cnh;
    }

    if(values.veiculo) {
      json[this.tipoPesquisaVeiculo] = values.veiculo;
    }

    try {
      let response = await this.realizarConsultaService.editarConsulta(json);
      return response;
    } catch (error) {
      console.error('erro ao editar consulta => ', error);
      return null;
    }

  }

}
